import{a as e}from"./chunk-QUXXAE7Y.mjs";import{b as m}from"./chunk-TN4M2PHH.mjs";import{h as o,i as r}from"./chunk-2JBE4HP3.mjs";var i=new o({locale:[e,m,r]});export{i as a};
